module.exports = __webpack_public_path__ + "static/media/icon_122.81e097f6.svg";